import React from 'react';
import { Action } from 'interface';
import * as actionTypes from 'store/action-types';
import { NotificationState } from 'interface/state';

const initialState: NotificationState = {
  isCompanyFilter: false,
};

const notificationReducer = (
  state: NotificationState = initialState,
  action: Action
) => {
  switch (action.type) {
    case actionTypes.SET_COMPANY_FILTER:
      return {
        ...state,
        isCompanyFilter: action.payload,
      };
    default:
      return state;
  }
};

export default notificationReducer;
